export default {
    title: {
        hotPromotion: 'Hot Promotion',
        special4You: 'My Exclusive Deal',
        promoCode: 'Promo code',
        searchPromotion: 'Search Promotions'
    },
    bottomSheet: {
        register: 'Reminder ** Register your JCB card in “My Account” menu to receive your exclusive deal and JCB hot promotion.',
        confirmRedeemDesc: 'Please ensure the conditions before proceeding.',
        addCard: 'Please add your JCB credit card to receive many privilege'
    },
    tabs: {
        detail: 'Details',
        condition: 'Conditions'
    },
    historyTabs: {
        available: 'Available',
        usedExpired: 'Used / Expired'
    },
    body:{
        period: "PERIOD",
        presentCode: "Please present code below to the cashier for redemption",
    },
    comingSoon: "<p class='mb-2'>Details of the promotion will appear soon,</p> <p>JCB will select the exclusive deal especially for you.<br /> Stay tuned with us.</p>",
}
